import { REVIEW_COPY, REVIEW_STAR_NAMES, type ReviewStars as Stars } from "@fusiqo/vozqi-shared";

const ALL: Stars[] = [1, 2, 3, 4, 5];

/**
 * A REVIEW'S STARS. With `onChange`, five big buttons, one press per star,
 * and the chosen one named («Excelente» … «Muy mala», spec 2026-10-21 §6.1);
 * without, the stars a review was given, read only. In the kit because the
 * profile's light entry (`share/`) reads it too.
 */
export function ReviewStars({ value, onChange }: { value: Stars | null; onChange?: (stars: Stars) => void }) {
  const shown = value ?? 0;
  if (onChange === undefined) {
    return (
      <span role="img" aria-label={REVIEW_COPY.starsLabel(shown)} style={{ fontSize: 18, letterSpacing: 2, lineHeight: 1 }}>
        {ALL.map((n) => (
          <span key={n} style={{ color: n <= shown ? "var(--warn)" : "var(--line)" }}>
            ★
          </span>
        ))}
      </span>
    );
  }
  return (
    <div style={{ display: "grid", gap: 6, justifyItems: "start" }}>
      <div style={{ display: "flex", gap: 4 }}>
        {ALL.map((n) => (
          <button
            key={n}
            type="button"
            aria-label={REVIEW_COPY.starsLabel(n)}
            aria-pressed={value === n}
            onClick={() => onChange(n)}
            style={{
              minWidth: 44,
              minHeight: 44,
              padding: 0,
              border: "none",
              background: "none",
              cursor: "pointer",
              fontSize: 36,
              lineHeight: 1,
              color: n <= shown ? "var(--warn)" : "var(--line)",
            }}
          >
            ★
          </button>
        ))}
      </div>
      {value === null ? null : <span style={{ fontWeight: 600 }}>{REVIEW_STAR_NAMES[value]}</span>}
    </div>
  );
}
